/**
 * Sort-option resolvers for the public artifact list toolbar. They reuse the
 * shared sort-option catalog and strip the person-based field (`assignee` for
 * tasks, `author` for notes) when the share anonymizes personal data.
 *
 * @module components/share/public/PublicArtifactList/parts/publicSortOptions
 */
import type { SortOption } from '@/components/ui/SortControls';
import {
  NOTE_PERSON_SORT_FIELD,
  NOTE_SORT_OPTIONS,
  OBSTRUCTION_SORT_OPTIONS,
  TASK_PERSON_SORT_FIELD,
  TASK_SORT_OPTIONS,
} from '@/constants/sortOptions';

/** Task sort options, hiding the assignee option when personal data is hidden. */
export function getTaskSortOptions(showPersonalData: boolean): SortOption[] {
  if (showPersonalData) return TASK_SORT_OPTIONS;
  return TASK_SORT_OPTIONS.filter(
    (option) => option.value !== TASK_PERSON_SORT_FIELD
  );
}

/** Note sort options, hiding the author option when personal data is hidden. */
export function getNoteSortOptions(showPersonalData: boolean): SortOption[] {
  if (showPersonalData) return NOTE_SORT_OPTIONS;
  return NOTE_SORT_OPTIONS.filter(
    (option) => option.value !== NOTE_PERSON_SORT_FIELD
  );
}

/** Obstruction sort options (no person-based field to strip). */
export function getObstructionSortOptions(): SortOption[] {
  return OBSTRUCTION_SORT_OPTIONS;
}
